import React, { useState, useEffect } from "react";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NotificationsCard from "../ProfileCommon/NotificationsCard";
import images from "../../../images";
import {
  useGetUserInfoQuery,
  usePostUpdateNotificationSettingsMutation,
} from "../../../services/apiSlice";
import { toastUtils } from "../../../Utils/helper";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import FooterContact from "../../../components/Footer/FooterContact";

const Notifications = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isCheckedQuest, setIsCheckedQuest] = useState(false);
  const [isCheckedUpdate, setIsCheckedUpdate] = useState(false);
  const accessToken =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  useEffect(() => {
    if (!accessToken) {
      navigate("/sign-in", { state: { from: "notifications" }, replace: true });
    }
  }, [accessToken, navigate]);
  const {
    data: userInfo,
    isLoading: isUserInfoLoading,
    refetch: refetchUserInfo,
  } = useGetUserInfoQuery({ skip: !accessToken });
  const [postUpdateNotificationSettings, { isLoading: isUpdating }] =
    usePostUpdateNotificationSettingsMutation({
      skip: !accessToken,
    });

  // Update toggle states based on userInfo when it loads or changes
  useEffect(() => {
    if (userInfo) {
      setIsCheckedQuest(userInfo.data.new_quest_alert || false);
      setIsCheckedUpdate(userInfo.data.consent_marketing || false);
    }
  }, [userInfo]);

  const handleUpdate = async () => {
    try {
      const response = await postUpdateNotificationSettings({
        new_quest_alert: isCheckedQuest,
        consent_marketing: isCheckedUpdate,
      }).unwrap();
      // Immediately update local state to reflect the new values
      if (response.status === 200) {
        toastUtils.success("Notification settings updated successfully!");
        setIsCheckedQuest(response?.data?.new_quest_alert || isCheckedQuest);
        setIsCheckedUpdate(
          response?.data?.consent_marketing || isCheckedUpdate
        );
        // Refetch user info to sync with server state
        await refetchUserInfo();
      }
    } catch (error) {
      console.error("Failed to update notification settings:", error);
    }
  };

  return (
    <div className="flex flex-col w-full max-w-[480px] h-full bg-white overflow-y-auto">
      <LoadingCommon statusLoading={isUserInfoLoading || isUpdating} />
      <div className="flex flex-col w-full ">
        <div className="flex flex-col flex-1 gap-6 px-[30px]">
          <Breadcrumb
            breadCrumbTiltle={t("profile.notificationsSettings")}
            onClickBack={() =>
              navigate("/profile", {
                state: { direction: -1 },
                replace: false,
              })
            }
          />

          <p className="text-[#253FF6] font-[Figtree] text-[14px] xs:text-[16px] font-medium not-italic leading-[24px]">
            Via Whatsapp broadcast message.
          </p>
        </div>
        <div>
          <NotificationsCard
            image={images.StartIconSVG}
            title="New Quest Alerts"
            content="Be notified of new quests that you are eligible for."
            checked={isCheckedQuest}
            onChange={() => setIsCheckedQuest(!isCheckedQuest)}
          />
          <NotificationsCard
            image={images.UpdateIconSVG}
            title="News & Updates"
            content="Keep up to date with our news and updates about Rally."
            checked={isCheckedUpdate}
            onChange={() => setIsCheckedUpdate(!isCheckedUpdate)}
          />
        </div>

        <div className="w-full flex justify-center px-4">
          <button
            onClick={handleUpdate}
            className="gap-2.5 self-stretch px-5 max-w-[368px] mt-5 w-full text-[18px] xs:text-xl font-medium tracking-tight text-center bg-[#253FF6] text-white rounded-md border border-[#253FF6] border-solid min-h-[50px]"
          >
            {t("base.save")}
          </button>
        </div>
      </div>
      <FooterContact className={"!bg-white"} />
    </div>
  );
};

export default Notifications;
